<template>
  <v-dialog :model-value="DialogMembers">
    <v-card rounded="lg">
      <v-toolbar class="toolbar-color">
        <v-toolbar-title class="text-white"
          ><v-icon color="white" class="mr-2" size="small"
            >mdi-account-group</v-icon
          >Members</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-select
          variant="outlined"
          rounded="lg"
          density="compact"
          label="Status"
          max-width="120"
          class="mt-5 mr-2 members-field-color text-white"
          v-model="selected_status"
          :items="StatusItems"
        ></v-select>
        <v-text-field
          variant="outlined"
          density="compact"
          rounded="lg"
          prepend-inner-icon="mdi-magnify"
          max-width="200"
          class="mt-5 members-field-color text-white"
          v-model="search"
        ></v-text-field>
        <v-btn icon elevation="0" @click="DialogMembersEmit(1)">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        hide-default-footer
        fixed-header
        :headers="TableHeaders"
        :items="ListAllMembers"
        :search="search"
        :height="CommonVuetifyObj.height - 245"
        :items-per-page="itemsPerPage"
        :page="page"
        :footer-props="{
          'items-per-page-options': [10],
        }"
        :loading="loading"
        no-data-text="Sorry, there are currently no members in this team!"
      >
        <template v-slot:[`item.full_user_name`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-account</v-icon>
            <div class="ml-2">{{ item.full_user_name || "-" }}</div>
          </div>
        </template>

        <template v-slot:[`item.member_id`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-id-card</v-icon>
            <div class="ml-2">{{ item.member_id || "-" }}</div>
          </div>
        </template>

        <template v-slot:[`item.user_created_on`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-clock-outline</v-icon>
            <div class="ml-2">
              {{ ConvertDate(item.user_created_on) || "-" }}
            </div>
          </div>
        </template>

        <template v-slot:[`item.user_email_id`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-email-outline</v-icon>
            <div class="ml-2">{{ item.user_email_id || "-" }}</div>
          </div>
        </template>

        <template v-slot:[`item.user_contact_number`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-phone</v-icon>
            <div class="ml-2">+91 {{ item.user_contact_number || "-" }}</div>
          </div>
        </template>

        <template v-slot:[`item.user_status`]="{ item }">
          <v-chip :color="item.user_status === 'JOINED' ? 'green' : 'red'">
            <div>
              {{ item.user_status === "JOINED" ? "Active" : "Inactive" }}
            </div>
          </v-chip>
        </template>

        <template v-slot:[`item.device_type`]="{ item }">
          <div class="d-flex align-center">
            <v-icon
              v-if="item.device_type === 'ANDROID'"
              class="icon-color"
              size="small"
              >mdi-android</v-icon
            >
            <v-icon v-else class="icon-color" size="small">mdi-apple</v-icon>
            <div class="ml-2">{{ item.device_type || "-" }}</div>
          </div>
        </template>

        <template v-slot:[`item.app_version`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="icon-color" size="small">mdi-pan-vertical</v-icon>
            <div class="ml-2">{{ item.app_version || "-" }}</div>
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        density="compact"
        class="v-pagination-item"
        :total-visible="1"
        :length="pageCount"
      ></v-pagination>
    </v-card>
  </v-dialog>
</template>

<script>
import { useDisplay } from "vuetify/lib/framework.mjs";
import { GetAllListUsers } from "@/mixins/Teams/GetAllListUsers";

export default {
  props: { DialogMembers: Boolean, organizationId: String },
  mixins: [GetAllListUsers],
  data: () => ({
    page: 1,
    previous_page: 0,
    itemsPerPage: 10,

    search: "",
    selected_status: "ALL",

    CommonVuetifyObj: {},

    ListAllMembers: [],
    TableHeaders: [
      { title: "Member Name", value: "full_user_name" },
      { title: "Member ID", value: "member_id" },
      { title: "Created On", value: "user_created_on" },
      { title: "Email", value: "user_email_id" },
      { title: "Contact No.", value: "user_contact_number" },
      { title: "Status", value: "user_status" },
      { title: "Device Type", value: "device_type" },
      { title: "App Version", value: "app_version" },
    ],
    StatusItems: [
      { title: "All", value: "ALL" },
      { title: "Active", value: "ACTIVE" },
      { title: "Inactive", value: "DEACTIVE" },
      { title: "Invited", value: "INVITED" },
      { title: "Disabled", value: "DISABLED" },
    ],
    loading: false,
  }),
  watch: {
    async DialogMembers(val) {
      if (val == true) {
        this.loading = true;
        await this.GetAllListUsersMethod(this.organizationId);
        this.loading = false;
      }
    },
    async selected_status(val) {
      if (val) {
        this.loading = true;
        await this.GetAllListUsersMethod(this.organizationId);
        this.loading = false;
      }
    },
    async page(val) {
      if (val > this.previous_page) {
        this.loading = true;
        await this.GetAllListUsersMethod(this.organizationId);
        this.loading = false;
      }
      if (val > this.previous_page) {
        this.previous_page = val;
      }
    },
  },
  computed: {
    pageCount() {
      return Math.ceil(this.ListAllMembers.length / this.itemsPerPage);
    },
  },
  async mounted() {
    this.CommonVuetifyObj = useDisplay();
  },
  methods: {
    DialogMembersEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
    ConvertDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>

<style>
.toolbar-color {
  background: linear-gradient(135deg, #3f78e0 0%, #da4c77 100%) !important;
}
.icon-color {
  background: linear-gradient(135deg, #1967c0 0%, #75a3d9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.members-field-color .v-field--variant-outlined {
  --v-border-color: white !important;
  padding: 2px !important;
}
.v-pagination-item--is-active {
  background: linear-gradient(135deg, #3f78e0 0%, #da4c77 100%) !important;
  color: white;
}
</style>
